<p-dialog appDialogoPadrao="pi pi-briefcase" descricao="Serviço exibido no portal." [visible]="visivel()" (visibleChange)="visivel.set($event)" [dismissableMask]="true" [header]="tituloModal" [style]="{ width: '560px', maxWidth: '95vw' }">
    <form [formGroup]="form" class="flex flex-col gap-4 pt-2">
        <div class="flex flex-col gap-1">
            <label for="sv-nome" class="text-sm font-semibold">Nome <span class="text-red-500">*</span></label>
            <input id="sv-nome" pInputText type="text" formControlName="servico" maxlength="50" placeholder="Ex.: Intranet CRM" />
            @if (form.controls.servico.invalid && form.controls.servico.touched) {
                <small class="text-red-500">Informe o nome (até 50 caracteres).</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="sv-desc" class="text-sm font-semibold">Descrição <span class="text-red-500">*</span></label>
            <input id="sv-desc" pInputText type="text" formControlName="descricao" maxlength="150" placeholder="Breve descrição do serviço" />
            @if (form.controls.descricao.invalid && form.controls.descricao.touched) {
                <small class="text-red-500">Informe a descrição (até 150 caracteres).</small>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label for="sv-url" class="text-sm font-semibold">URL <span class="text-red-500">*</span></label>
            <input id="sv-url" pInputText type="url" formControlName="url" maxlength="500" placeholder="https://..." />
            @if (form.controls.url.invalid && form.controls.url.touched) {
                <small class="text-red-500">Informe a URL de acesso.</small>
            }
        </div>

        <div class="flex items-end gap-4">
            <div class="flex flex-col gap-1 flex-1 min-w-0">
                <label class="text-sm font-semibold">UF <span class="text-red-500">*</span></label>
                <app-estado-select [uf]="form.controls.uf.value" [disabled]="ufTravada()" (ufChange)="onUfChange($event)" />
            </div>
            @if (mostrarDivulgar()) {
                <div class="flex flex-col gap-1">
                    <label class="text-sm font-semibold" for="sv-divulga">Divulgar</label>
                    <div class="flex items-center h-[2.5rem]">
                        <p-toggleswitch inputId="sv-divulga" formControlName="divulga" ariaLabel="Divulgar serviço no bloco do CFM" />
                    </div>
                </div>
            }
        </div>

        <div class="flex flex-col gap-1">
            <label class="text-sm font-semibold">Ícone <span class="text-red-500">*</span></label>
            <div class="flex items-center gap-2">
                <span class="servico-icone-preview">
                    <i [class]="iconeAtual || 'pi pi-image'" aria-hidden="true"></i>
                </span>
                <input pInputText type="text" class="flex-1" [value]="iconeAtual" readonly placeholder="Nenhum ícone selecionado" aria-label="Ícone selecionado" />
                <p-button label="Escolher" icon="pi pi-search" [outlined]="true" (onClick)="abrirSeletor()" />
            </div>
            @if (form.controls.icon.invalid && form.controls.icon.touched) {
                <small class="text-red-500">Selecione um ícone.</small>
            }
        </div>
    </form>

    <ng-template pTemplate="footer">
        <p-button label="Cancelar" [text]="true" (onClick)="fechar()" />
        <p-button label="Salvar" icon="pi pi-check" [loading]="salvando()" (onClick)="salvar()" [appCan]="roleServicosEditar" />
    </ng-template>
</p-dialog>

<app-seletor-icone [visivel]="seletorAberto()" (visivelChange)="seletorAberto.set($event)" [selecionado]="iconeAtual" (onSelecionar)="onIconeSelecionado($event)" />
